import React, { useEffect, useReducer, useRef, useState } from "react";
import styles from "./MyQuizzes.module.css"; // Import the CSS file
import axios from "axios";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "@mui/icons-material";
import { useLocation, useNavigate } from "react-router-dom";
import { usePreference } from "../../context/UserContext";
import AdvertisementModel from "../../common/AdvertisementModel";
import PayPalModal from "../paypal/PaypalModel";
import QuizzesModel from "../../common/QuizzesModel";
import ShowCart from "../ShowCart";
import Swal from "sweetalert2";
import { Backdrop, CircularProgress } from "@mui/material";

const MyQuizzes = () => {
  const location = useLocation();
  const { subcategories = [] } = location.state || {};
  const navigate = useNavigate();
  const {
    updateIsLoginOpen,
    updateIsSignUpOpen,
    updateIsNavVisible,
    showCart,
    updateShowCart,
    cart,
    updateCart,
  } = usePreference();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [data, setData] = useState([]);
  const [expandedPacks, setExpandedPacks] = useState({});
  const [filteredData, setFilteredData] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const userRole = localStorage.getItem("userrole");
  const [openQuizModel, setOpenQuizModel] = useState(false);
  const [catId, setCatId] = useState(0);
  const [selectedId, setSelectedId] = useState(0);
  const [isCollectionId, setIsCollectionId] = useState(false);
  const [isMonthly, setIsMonthly] = useState(false);
  const [amount, setAmount] = useState(1);
  const [filteredCart, setFilteredCart] = useState([]);
  const [showPaypalModel, setShowPaypalModel] = useState(false);
  const [pack, setPack] = useState({});
  const [isOpenAdd, setIsOpenAdd] = useState(false);
  const scrollContainerRefs = useRef({});
  const { id } = useParams();
  const [quizzes, setQuizzes] = useState([]);
  const appToken = localStorage.getItem("webtoken");
  const username = localStorage.getItem("username");
  const auth = "Bearer " + appToken;

  useEffect(() => {
    const token = localStorage.getItem("username");
    setIsLoggedIn(!!token);
  }, []);
  useEffect(() => {
    document.head.insertAdjacentHTML(
      "beforeend",
      `<style>@keyframes blink {0%{opacity:1;}50%{opacity:0.5;}100%{opacity:1;}}</style>`
    );
  }, []);

  useEffect(() => {
    updateIsNavVisible(true);
    const fetchData = async () => {
      setFilteredData([subcategories]);
    };
    fetchData();
  }, [username, userRole, subcategories, updateIsNavVisible]);

  useEffect(() => {
    if (cart.length === 0) {
      updateShowCart(false);
    } else {
      const filteredCartData = cart.map((item) => ({
        packId: item.packId,
        price: item.price,
        isCollection: item.isCollection,
        type: item.type === "monthly",
      }));
      setFilteredCart(filteredCartData);
    }
  }, [cart, updateShowCart]);

  useEffect(() => {
    const savedCart = localStorage.getItem("cart");
    if (savedCart) updateCart(JSON.parse(savedCart));
  }, [updateCart]);

  useEffect(() => {
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `https://s3napi-dev.s3nsoftware.com/api/UserQuizs/GetQuizzes?Username=${username}`,
      headers: {
        Authorization: auth.toString(),
      },
    };

    axios
      .request(config)
      .then((response) => {
        setQuizzes(response.data);
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const getQuizUrlByGradeIndex = (index) => {
    if (index === 0 || index === 1) return "/playquiz/56";
    if (index === 2 || index === 3) return "/playquiz/57";
    if (index >= 4 && index <= 7) return "/playquiz/58";
    return "/";
  };

  const getQuizPackMessage = (index) => {
    if (index === 0 || index === 1) return "(Dictionary 1 recommended)";
    if (index === 2) return "(Dictionary 2 recommended)";
    if (index === 3) return "(Dict 3 recommended)";
    if (index >= 4 && index <= 7) return "(Dictionary 4 and 5 recommended)";
    return "";
  };

  const togglePackVisibility = (packId) => {
    setExpandedPacks((prev) => ({
      ...prev,
      [packId]: !prev[packId],
    }));
  };

  const updateQuizId = (value) => {
    navigate(`/playquiz/${value}`);
  };

  const addToCart = (pack, type, price, isCollection, action, packname) => {
    updateShowCart(true);
    updateCart((prevCart) => {
      const currentCart = Array.isArray(prevCart) ? prevCart : [];
      if (action === "add") {
        const itemAlreadyInCart = currentCart.some(
          (item) =>
            item.packId === pack.Id && item.isCollection === isCollection
        );
        if (itemAlreadyInCart) {
          Swal.fire({
            title: "Info",
            text: "This item is already in your cart.",
            icon: "info",
          });
          return currentCart;
        }
        if (isCollection) {
          if (Array.isArray(pack.Categories)) {
            const categoryAlreadyInCart = currentCart.some((item) =>
              pack.Categories.some(
                (category) => item.packId === category.CollectionId
              )
            );
            if (categoryAlreadyInCart) {
              Swal.fire({
                title: "Alert",
                text: "Some categories from this collection are already in your cart. Please remove them first if you wish to add the entire collection.",
                icon: "warning",
              });
              return currentCart;
            }
            const updatedCart = currentCart.filter(
              (item) =>
                !pack.Categories.some(
                  (category) => item.packId === category.CollectionId
                )
            );
            const newCartItem = {
              pack,
              packId: pack.Id,
              type,
              price,
              isCollection,
              packname,
            };
            const newCart = [...updatedCart, newCartItem];
            localStorage.setItem("cart", JSON.stringify(newCart));
            return newCart;
          }
        } else {
          const collectionInCart = currentCart.some(
            (item) => item.packId === pack.CollectionId
          );
          if (collectionInCart) {
            Swal.fire({
              title: "Alert",
              text: "The collection containing this category is already in your cart. You cannot add individual categories from the collection.",
              icon: "warning",
            });
            return currentCart;
          }
          const newCartItem = {
            pack,
            packId: pack.Id,
            type,
            price,
            isCollection: false,
            packname,
          };
          const newCart = [...currentCart, newCartItem];
          localStorage.setItem("cart", JSON.stringify(newCart));
          return newCart;
        }
      } else if (action === "remove") {
        const updatedCart = currentCart.filter(
          (item) =>
            !(item.packId === pack.Id && item.isCollection === isCollection)
        );
        localStorage.setItem("cart", JSON.stringify(updatedCart));
        return updatedCart;
      }
    });
  };

  const handleCheckout = () => {
    const loggedin = localStorage.getItem("loggedin");
    if (!loggedin || loggedin === "false") {
      Swal.fire({
        icon: "warning",
        text: "Please login or signup to subscribe",
        showCancelButton: true,
        showDenyButton: true,
        confirmButtonText: "Login",
        denyButtonText: "Sign Up",
        cancelButtonText: "Cancel",
      }).then((result) => {
        if (result.isConfirmed) {
          updateIsLoginOpen(true);
          updateIsSignUpOpen(false);
        } else if (result.isDenied) {
          updateIsSignUpOpen(true);
          updateIsLoginOpen(false);
        }
      });
      return;
    }
    setAmount(calculateTotal());
    setShowPaypalModel(true);
  };

  const deleteItem = (packId, type) => {
    updateCart((prevCart) => {
      const updatedCart = prevCart.filter(
        (item) => !(item.packId === packId && item.type === type)
      );
      localStorage.setItem("cart", JSON.stringify(updatedCart));
      return updatedCart;
    });
  };

  const toggleCartVisibility = () => {
    updateShowCart(!showCart);
  };

  const calculateTotal = () => {
    return cart.reduce((sum, item) => sum + item.price, 0).toFixed(2);
  };

  const updateQuizModel = (value) => {
    setOpenQuizModel(value);
  };

  const updateShowPaypalModel = (value) => {
    setShowPaypalModel(value);
  };

  const updateOpenAdd = (value) => {
    setIsOpenAdd(value);
  };

  if (!isLoggedIn) {
    return (
      <div className="container mt-5 text-center">
        <h6>Please login to view the page</h6>
        <button
          className="btn btn-primary mt-3"
          onClick={() => {
            navigate("/");
            updateIsLoginOpen(true);
          }}
        >
          Go to Login
        </button>
      </div>
    );
  }

  return (
    <>
      {" "}
      {showCart && (
        <ShowCart
          showCart={showCart}
          toggleCartVisibility={toggleCartVisibility}
          cart={cart}
          deleteItem={deleteItem}
          handleCheckout={handleCheckout}
          calculateTotal={calculateTotal}
          filteredCart={filteredCart}
        />
      )}
      {openQuizModel && (
        <QuizzesModel
          open={openQuizModel}
          updateQuizModel={updateQuizModel}
          catId={catId}
          updateQuizId={updateQuizId}
          pack={pack}
        />
      )}
      <PayPalModal
        showPaypalModel={showPaypalModel}
        updateShowPaypalModel={updateShowPaypalModel}
        amount={amount}
        SelectedId={12}
        IsCollectionId={true}
        IsMonthly={true}
        Username={username}
        cartdata={cart}
        filteredCart={filteredCart}
      />
      <AdvertisementModel open={isOpenAdd} updateIsOpen={updateOpenAdd} />
      <div className="container w-50">
        {/* <button
          style={{
            position: "absolute",
            top: "16px",
            left: "16px",
            display: "flex",
            alignItems: "center",
            gap: "8px",
            padding: "6px 12px",
            backgroundColor: "#e5e7eb",
            color: "#374151",
            borderRadius: "12px",
            border: "none",
            cursor: "pointer",
            transition: "all 0.2s ease-in-out",
          }}
        >
          <a
            href="/"
            style={{
              display: "flex",
              alignItems: "center",
              textDecoration: "none",
              color: "inherit",
            }}
          >
            <ArrowLeft size={20} />
            <span style={{ fontSize: "16px", fontWeight: "500" }}>Back</span>
          </a>
        </button> */}
        {loading ? (
          <Backdrop
            sx={{
              color: "#000",
              backgroundColor: "rgba(255, 255, 255, 0.5)",
              zIndex: (theme) => theme.zIndex.drawer + 1,
            }}
            open={loading}
          >
            <div style={{ textAlign: "center" }}>
              <CircularProgress sx={{ color: "#007bff" }} />
              <p style={{ marginTop: "8px", fontWeight: "500" }}>Loading...</p>
            </div>
          </Backdrop>
        ) : quizzes.length === 0 ? (
          <p className={`${styles.message} ${styles.noQuizzes}`}>
            🚫 No quizzes available at the moment. Try again later!
          </p>
        ) : (
          quizzes.map((item, index) => (
            <div key={index} className={styles.quiz_stats_container}>
              <div className={styles.progress_circle}>
                <span>{item.Percentage}</span>
              </div>
              <div className={styles.quiz_details}>
                {/* {item.CatSubCat.split(",")[0]} */}
                <Link
                  to={`/playquiz/${item.CatSubCat.split(",")[0]}`}
                  state={{
                    quizid: item.QuizId,
                    catSubCat: item.CatSubCat.split(",")[1],
                  }}
                >
                  <h3>{item.QuizNumber}</h3>
                </Link>
                <div className={styles.stats}>
                  <span className={styles.correct}>
                    {item.Description.split(",")[0]}
                  </span>
                  <span className={styles.incorrect}>
                    {item.Description.split(",")[1]}
                  </span>
                  <span className={styles.unattempted}>
                    {item.Description.split(",")[2]}
                  </span>
                </div>
              </div>
              <div className={styles.action_icons}>
                <i className={styles.info_icon}></i>
                <i className={styles.refresh_icon}></i>
              </div>
            </div>
          ))
        )}
      </div>
    </>
  );
};

export default MyQuizzes;
